import React from 'react';
import { Box } from '@mui/material';

import type { TextOperationType } from '../../../domain';
import type { TextPanelProps } from './panelProps';
import { GeneratePanel } from './GeneratePanel';
import { ContinuePanel } from './ContinuePanel';
import { ExpandPanel } from './ExpandPanel';
import { RefinePanel } from './RefinePanel';
import { RestructurePanel } from './RestructurePanel';
import { StylizePanel } from './StylizePanel';
import { CritiquePanel } from './CritiquePanel';
import { DistillPanel } from './DistillPanel';

interface Props extends TextPanelProps {
  kind: TextOperationType;
}

/** Dispatches to the active text-operation panel. Mirrors Image Lab's OperationPanel. */
export const TextOperationPanel: React.FC<Props> = ({ kind, ...rest }) => {
  const wrap = (children: React.ReactNode) => (
    <Box sx={{ p: 2, borderTop: theme => `1px solid ${theme.palette.divider}` }}>{children}</Box>
  );

  switch (kind) {
    case 'Generate':
      return wrap(<GeneratePanel {...rest} />);
    case 'Continue':
      return wrap(<ContinuePanel {...rest} />);
    case 'Expand':
      return wrap(<ExpandPanel {...rest} />);
    case 'Refine':
      return wrap(<RefinePanel {...rest} />);
    case 'Restructure':
      return wrap(<RestructurePanel {...rest} />);
    case 'Stylize':
      return wrap(<StylizePanel {...rest} />);
    case 'Critique':
      return wrap(<CritiquePanel {...rest} />);
    case 'Distill':
      return wrap(<DistillPanel {...rest} />);
    default:
      return null;
  }
};
